/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

 

import React, { useContext, useEffect, useState } from "react";
import "./Sheet.css";
import { nanoid } from "nanoid";
import TextBox from "./TextBox";
import { deleteById, normalizeBase64Image, parseTemplateData, parseTemplateTextContent, pushX } from "./utils";
import { tracker } from "./tracker";

function Sheet(props) {
  const readOnly = props?.readOnly ?? true;
  const key = props.id ?? nanoid(5);
  const [data, setData] = useState(props.data);

  useEffect(() => setData(props.data), [props.data]);

  function handleDeleteTextBox(id, index) {
    const data_ = { ...data };
    data_.content = deleteById(id, index, data.content);

    tracker([{ type: "deleteText" }], {
      docId: props.docId,
      key: id,
    });
    setData(data_);
  }

  function handleContextMenu(e) {
    e.preventDefault();

    // if (userData?.permission?.permission_name === "translator") return;
    props.onContextMenu(e, key);
  }

  useEffect(() => {
    const payload = props.insertText;
    // console.log(payload);
    if (!payload) {
      return;
    }
    if (`sheet-id--${key}` === payload?.id) {
      console.log("TRIGGER ", key, payload);
      const data_ = { ...data };
      data_.content = pushX(payload.content, data.content);

      if (data_.content.length === data.content.length) return;

      const htmlContent = parseTemplateData(payload.content.data);
      const textContent = parseTemplateTextContent(htmlContent);

      const value = {
        id: payload.content.id,
        pageid: key,
        html: htmlContent,
        text: textContent,
        sourceText: "",
        originalText: textContent,
        position: payload.content.position,
        fontSize: payload.content.style.size,
      };

      tracker([{ type: "insertText" }], {
        docId: props.docId,
        value,
        key: value.id,
      });

      setData(data_);
    } else {
      return;
    }
  }, [props.insertText]);

  return (
    <div className="pdf-sheet-wrap" style={{ zoom: props.scale }}>
      <div style={{ width: 12, height: "100%", background: "none" }} />
      <div
        key={key}
        datakey={key}
        dataindex={props.index}
        id={`sheet-id--${key}`}
        className="pdf-sheet"
        style={{ ...props.style }}
        onContextMenu={handleContextMenu}
      >
        {props.bg && (
          <img
            src={normalizeBase64Image(props.bg)}
            className="sheet-bg"
            style={{
              width: "100%",
              height: "100%",
              userSelect: "none",
            }}
            alt=""
          />
        )}

        {data.content
          .filter((d) => d.action !== "deleted")
          .map((d, idx) => (
            <TextBox
              key={d.id}
              docId={props.docId}
              index={idx}
              pageIndex={props.index}
              readOnly={readOnly}
              id={d.id}
              content={d}
              pageId={key}
              onDelete={handleDeleteTextBox}
              strict={props.strict}
              // onContextMenu={(e) => props.onContextMenu(e, key)}
            />
          ))}
      </div>
    </div>
  );
}

export default Sheet;
